import axiosInstance from "./axiosConfig";

class LegalService {
  static async getSuppliersPrivacyPolicy() {
    try {
      return await axiosInstance.get("public/legal/privacy-policy/suppliers");
    } catch (error) {
      console.error("Erro ao buscar política de privacidade:", error?.response?.data || error.message);
      throw error;
    }
  }
}

export default LegalService;
